import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Card } from '../../shared/components';
import { api } from '../../utils/api';
import './CollegeAlgebra.css';

export default function UnitDetail() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    setData(null);
    setError('');
    api
      .get(`/api/college-algebra/units/${slug}`)
      .then(setData)
      .catch(() => setError('Unable to load this unit right now.'));
  }, [slug]);

  if (error) return <p className="ca-error">{error}</p>;
  if (!data) return <p>Loading unit&hellip;</p>;

  const { unit, lessons } = data;

  return (
    <div className="ca-page">
      <Link to="/college-algebra" className="ca-back-link">&larr; Back to units</Link>
      <h1>{unit.name}</h1>
      <p className="ca-page-intro">{unit.description}</p>

      <div className="ca-unit-actions">
        <Link to={`/college-algebra/units/${unit.slug}/quiz`}>
          <Button>Practice quiz</Button>
        </Link>
        <Link to={`/college-algebra/units/${unit.slug}/test`}>
          <Button variant="secondary">Unit test</Button>
        </Link>
      </div>

      <h2 className="ca-lessons-heading">Lessons</h2>
      <Card>
        <div className="ca-lesson-list">
          {lessons.map((lesson) => (
            <Link key={lesson.id} to={`/college-algebra/lessons/${lesson.slug}`} className="ca-lesson-row">
              <span className="ca-lesson-row-title">{lesson.title}</span>
              <span className="ca-lesson-row-arrow">&rarr;</span>
            </Link>
          ))}
        </div>
      </Card>
    </div>
  );
}
